import { render } from "./MoreStudentDetails.vue?vue&type=template&id=fc400b8c&scoped=true"
import script from "./MoreStudentDetails.vue?vue&type=script&lang=js"
export * from "./MoreStudentDetails.vue?vue&type=script&lang=js"

import "./MoreStudentDetails.vue?vue&type=style&index=0&id=fc400b8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc400b8c"]])

export default __exports__